import Avatar from 'components/Avatar'
import BrowseDefaultIcon from 'components/icons/BrowseDefaultIcon'
import RightArrow from 'components/icons/RightArrow'
import React from 'react'

import {
  MainHeading,
  SecondGreyText,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const SocialMediaLinks = ({ studentData }) => {
  return (
    <>
      <MainHeading>Social Media Links</MainHeading>
      {studentData?.studentPersonalProfile?.socialMedia.length
        ? studentData?.studentPersonalProfile?.socialMedia.map((val, index) => (
            <SubFLex key={index + 'valueLink'}>
              <a href={val.link}>
                <SubFLex centerVertically gap="10px">
                  <div>
                    <Avatar
                      src={''}
                      size={24}
                      icon={<BrowseDefaultIcon />}
                      background="none"
                    />
                  </div>

                  <SecondGreyText marginBottom="0">{val.link}</SecondGreyText>

                  <RightArrow />
                </SubFLex>
              </a>
            </SubFLex>
          ))
        : null}
    </>
  )
}

export default SocialMediaLinks
